var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadastroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 75.0001V58.3334H150V75.0001H75ZM75 100V83.3334H150V100H75ZM100 183.333H50C43.0556 183.333 37.1528 180.903 32.2917 176.042C27.4306 171.181 25 165.278 25 158.333V133.333H50V16.6667H175V91.8751C172.222 91.5973 169.41 91.7015 166.562 92.1876C163.715 92.6737 160.972 93.5417 158.333 94.7917V33.3334H66.6667V133.333H116.667L100 150H41.6667V158.333C41.6667 160.695 42.4653 162.674 44.0625 164.271C45.6597 165.868 47.6389 166.667 50 166.667H100V183.333ZM116.667 183.333V157.708L162.708 111.875C163.958 110.625 165.347 109.722 166.875 109.167C168.403 108.611 169.931 108.333 171.458 108.333C173.125 108.333 174.722 108.646 176.25 109.271C177.778 109.896 179.167 110.833 180.417 112.083L188.125 119.792C189.236 121.042 190.104 122.431 190.729 123.958C191.354 125.486 191.667 127.014 191.667 128.542C191.667 130.07 191.389 131.632 190.833 133.229C190.278 134.826 189.375 136.25 188.125 137.5L142.292 183.333H116.667ZM129.167 170.833H137.083L162.292 145.417L158.542 141.458L154.583 137.708L129.167 162.917V170.833ZM158.542 141.458L154.583 137.708L162.292 145.417L158.542 141.458Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadastroIcon);
export default __webpack_public_path__ + "static/media/cadastroIcon.b01d94332532e1ad26a15f002ec0c1b4.svg";
export { ForwardRef as ReactComponent };